<template>
    <ListingWrapperLoadingState v-if="loading" />
    <div v-else class="listing-wrapper">
        <LayoutHeadingTabs :title="title">
            <template #tabs>
                <slot name="listingTabs" />
            </template>
            <template #actions>
                <slot name="listingActions" />
            </template>
        </LayoutHeadingTabs>
        <div class="listing-wrapper__table-container">
            <div class="listing-wrapper-settings-header__container">
                <slot name="settings" />
            </div>

            <slot name="table" />

            <TablePagination
                v-if="paginationData.total > 0"
                :pagination="paginationData"
                :isLoading="isTableLoading"
                class="listing-wrapper__pagination"
                @update-pagination="updatePagination"
            />
        </div>
    </div>
</template>

<script>
import LayoutHeadingTabs from 'vcomponents/common/layout/LayoutHeadingTabs.vue';
import ListingWrapperLoadingState from 'vcomponents/common/listing/ListingWrapperLoadingState.vue';
import TablePagination from 'vcomponents/common/table/TablePagination.vue';

import { createNamespacedHelpers } from 'vuex';
const { mapGetters: listingSettingsGetters } = createNamespacedHelpers('listingSettingsStores');
export default {
    components: {
        LayoutHeadingTabs,
        ListingWrapperLoadingState,
        TablePagination,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        isTableLoading: {
            type: Boolean,
            default: false,
        },
        pagination: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            params: {
                limit: 25,
                offset: '',
            },
            listPreviousOffset: [null],
        };
    },
    computed: {
        ...listingSettingsGetters({ storePagination: 'getPagination' }),
        paginationData() {
            return this.pagination || this.storePagination;
        },
    },
    created() {
        if (this.paginationData) {
            this.params.limit = this.paginationData.limit;
            this.params.offset = this.paginationData.offset;
        }
    },
    methods: {
        updatePagination(newPagination) {
            this.params = newPagination;
            this.$emit('update-pagination', this.params);
        },
    },
};
</script>

<style lang="scss" scoped>
.listing-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;

    &__table-container {
        display: flex;
        flex-direction: column;
        max-height: calc(100% - 56px);
        background-color: var(--colors-common-background-default);
        border-radius: var(--spacing-0);
        padding: 0 var(--spacing-3);
        &::v-deep {
            .compass-table {
                height: 100%;
            }
        }
    }

    &-settings-header {
        &__container {
            display: flex;
            flex-direction: column;
        }

        &__pagination {
            align-self: flex-end;
        }
    }
}
</style>
